import styled from '@emotion/styled';
import { spacing, breakpoints } from '@naf/theme';
import { Text } from '@naf/text';

export const Heading = styled(Text)`
  margin: ${spacing.space64} 0 ${spacing.space16};

  @media (max-width: ${breakpoints.m}) {
    margin: ${spacing.space32} 0 0;
  }
`;
